// extracted by mini-css-extract-plugin
export default {"container":"Page404_container__jUwna","info":"Page404_info__zdzzH","logo":"Page404_logo__lRWqI","grey":"Page404_grey__D7yAb","errorImg":"Page404_errorImg__4unnn"};